import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import moment from 'moment';
import EmptyPage from '../../empty-page/emptyPage';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import { standardDate } from '../../../utils/formatDate';
import { ReactComponent as Download } from '../../../assets/icons/trvto_download.svg';
import Dialog from '../../dialogModal/dialogModal';
import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import ConfirmationModal from '../../tripStrap/tripStrapFun/cancelBooking';
import CommonTable from '../../reusable-ui-components/commonTable/CommonTable';
import { fetchActBookedOnDate } from '../activityDashboard/actDashboardFn/fetchactDashboardFn';
import { orgBookingCancelFun } from '../../../api/orgActAPI';
import { getTotalSeatCount } from '../../../utils/getTotalSeatCount';

//pagination not required as we are populating data from bookingId array.
//And data wont reach more than 200

export default function OrgActDateDetails() {
    const location = useLocation();
    const navigate = useNavigate();
    const [actDateDetails, setActDateDetails] = useState([]);
    const { actDateId, slotId } = useParams();
    const [slotDetails, setSlotDetails] = useState(null);
    const [addBo, setAddBo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [modal, setModal] = useState(false);
    const [cancelTripModal, setCancelTripModal] = useState(false);
    const [reviewModal, setReviewModal] = useState(false);
    const [rowData, setRowData] = useState({});
    const [messageType, setMessageType] = useState([]);
    const [messageData, setMessageData] = useState({
        msgType: 'whatsApp',
        whatsApp: '',
        message: ''
    });
    const [showModal, setShowModal] = useState(false);
    const [rowId, setRowId] = useState('');

    const refresh = () => {
        setLoad(!load);
    };

    const dummyMessageType = [
        { value: 'whatsApp', name: 'WhatsApp' },
        { value: 'rate', name: 'Rate' },
        { value: 'custom', name: 'Custom' }
    ];

    const now = moment();
    const start = moment(actDateDetails[0]?.startDate);
    const end = moment(actDateDetails[0]?.endDate);

    const actStatus = now.isBefore(start)
        ? 'Upcoming'
        : now.isBetween(start, end, undefined, '[]')
          ? 'In Progress'
          : 'Completed';

    const columns = [
        {
            label: 'Name',
            accessor: 'userDetails',
            render: (val) => val?.[0]?.name || 'N/A'
        },
        {
            label: 'Total Seats',
            accessor: 'totalSeats',
            render: (val) =>
                val?.map((seats, index) => (
                    <div key={index}>
                        {seats.name} - {seats.qty}
                    </div>
                ))
        },
        {
            label: 'Booked On',
            accessor: 'createdAt',
            render: (val) => (val ? new Date(val).toLocaleDateString('en-IN') : 'N/A')
        },
        {
            label: 'Payment',
            accessor: 'amountPaid',
            render: (val, row) => {
                const isReserved = Boolean(val?.isReserved);
                const isInstallment = Boolean(val?.isInstallment);

                if (!isReserved && !isInstallment) {
                    return <div style={{ textAlign: 'center' }}>Full payment<br />Paid: ₹{Number(val?.paid) || 0}</div>;
                }

                const total = Number(val?.total) || 0;
                const paid = Number(val?.paid) || 0;

                const totalSeats = getTotalSeatCount(row?.totalSeats) || row?.userDetails?.length || 0;

                let balance = 0;
                let paymentText = '';

                // ---------------------------------------
                // RESERVED BOOKING
                // ---------------------------------------
                if (isReserved) {
                    // reserve is an ARRAY
                    const reservePerSeat = Number(val?.reserve?.[0]?.amount) || 0;

                    const reservedAmount = reservePerSeat * totalSeats;

                    balance = Math.max(0, total - reservedAmount);

                    paymentText = `(₹${reservePerSeat}/seat)`;
                }

                // ---------------------------------------
                // INSTALLMENT BOOKING
                // ---------------------------------------
                if (isInstallment) {
                    const installmentPaid = Array.isArray(val?.installments)
                        ? val.installments.reduce((sum, installment) => {
                              return sum + (Number(installment?.amount) || Number(installment?.total) || 0);
                          }, 0)
                        : 0;

                    balance = Math.max(0, total - installmentPaid);

                    paymentText = `(₹${installmentPaid})`;
                }

                return (
                    <div
                        style={{
                            color: 'red',
                            textAlign: 'center',
                            whiteSpace: 'pre-line',
                            verticalAlign: 'middle'
                        }}
                    >
                        {`${isReserved ? 'Reserved' : 'Installment'}\n${paymentText}
Total: ₹${total}
Paid: ₹${paid}
Balance: ₹${balance}`}
                    </div>
                );
            }
        },
        {
            label: 'Booked Via',
            accessor: 'bookedVia',
            render: (val) => val || 'N/A'
        },
        {
            label: 'People',
            accessor: 'userDetails',
            render: (val) =>
                val?.length
                    ? val.map((user, index) => (
                          <div
                              key={index}
                              style={{
                                  marginBottom: '6px',
                                  whiteSpace: 'nowrap'
                              }}
                          >
                              {user.name}, {user.age}, {user.sex}, {user.phoneNumber}
                          </div>
                      ))
                    : 'N/A'
        },
        {
            label: 'Status',
            accessor: 'actStatus',
            render: (val) => (
                <span
                    style={{
                        color: val === 'Cancelled' ? 'red' : ''
                    }}
                >
                    {val || 'N/A'}
                </span>
            )
        },
        {
            label: 'Payment',
            accessor: 'paymentInfo',
            render: (val) => <span>{val.status || 'N/A'}</span>
        },
        {
            label: 'Action',
            accessor: 'action',
            render: (_, row) => {
                const slotDate = slotDetails?.date;

                if (!slotDate) {
                    return '-';
                }

                const isUpcoming = new Date(slotDate) > new Date();

                if (isUpcoming) {
                    return row?.actStatus === 'Cancelled' || row.paymentInfo.status === 'Pending' ? (
                        <span
                            style={{
                                color: 'red',
                                fontWeight: '600'
                            }}
                        >
                            --
                        </span>
                    ) : (
                        <span
                            className='cancelTrip-btn'
                            onClick={() => {
                                setShowModal(true);
                                setRowId(row._id);
                            }}
                        >
                            Cancel
                        </span>
                    );
                }

                return (
                    <span
                        style={{
                            color: 'green',
                            fontWeight: '600'
                        }}
                    >
                        Completed
                    </span>
                );
            }
        }
    ];

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        fetchActBookedOnDate(actDateId, slotId, setActDateDetails, setSlotDetails, setLoading);
        setMessageType(dummyMessageType);
        //eslint-disable-next-line
    }, [load]);

    async function handleBookingCancel(e) {
        e.stopPropagation();
        setLoading(true);

        try {
            const newDate = await orgBookingCancelFun({ bookingId: rowId });
            if (newDate.status === 200) {
                toast.success('Successfully cancelled Booking');
                setShowModal(false);
                refresh();
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }

    // async function handleTripCancel(e) {
    //     e.stopPropagation();
    //     setLoading(true);

    //     try {
    //         const newDate = await orgTripCancelFun({ packDateId: tripDateDetails._id });
    //         if (newDate.status === 200) {
    //             toast.success('Successfully cancelled trip');
    //             setCancelTripModal(false);
    //             navigate('/org/dashboard');
    //         }
    //         setLoading(false);
    //     } catch (error) {
    //         setLoading(false);
    //         errorHandle(error);
    //     }
    // }

    // async function handleStopReview(e) {
    //     e.stopPropagation();
    //     setLoading(true);

    //     try {
    //         const review = await stopReviewFun({ packDateId: tripDateDetails._id });
    //         if (review.status === 200) {
    //             toast.success('Successfully stopped review');
    //             setReviewModal(false);
    //         }
    //         setLoading(false);
    //     } catch (error) {
    //         setLoading(false);
    //         errorHandle(error);
    //     }
    // }

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            {/* <button className='backBtn hideOnPrint' onClick={() => navigate(-1)}>
                <img src={BackIcon} alt='back' />
                {`Back to Trip Details`}
            </button> */}
            {actDateDetails.length !== 0 ? (
                <div className='orgTripDateUpDiv'>
                    <div className='orgTripDateHeadingDiv'>
                        <h1 className='orgTripDateName'>{slotDetails?.activityName ?? 'N/A'}</h1>
                        <div>
                            <div>
                                <span className='orgTripDateSubDetails'>
                                    {slotDetails?.date ? standardDate(slotDetails.date.split('T')[0]) : 'N/A'}
                                </span>
                                <span className='orgTripDateDot'></span>
                                <span className='orgTripDateSubDetails'>
                                    {slotDetails?.startTime && slotDetails?.endTime
                                        ? `${slotDetails.startTime} - ${slotDetails.endTime}`
                                        : 'N/A'}
                                </span>

                                <span className='orgTripDateDot'></span>
                                <span className='orgTripDateSubDetails'>{slotDetails?.baseCities ?? 'N/A'}</span>
                            </div>
                        </div>
                    </div>
                    <div className='cardLayout'>
                        <div className='orgTripDateOverview'>
                            {/* {location.state !== 'completed' && (
                                <button
                                    className='orgPackCreateBtn blueBtn'
                                    onClick={() => {
                                        setModal(true);
                                        setRowData(tripDateDetails[0]?.packId._id);
                                    }}
                                >
                                    Send Message
                                </button>
                            )} */}
                            <div className='orgTripDateInfo'>
                                <span className='orgTripDateSpan'>Booked</span>
                                <span className='orgTripDateSpan'>
                                    {slotDetails?.bookedSlots ?? 0} / {slotDetails?.totalSlots ?? 0}
                                </span>
                            </div>
                            <div className='orgTripDateInfo'>
                                <span className='orgTripDateSpan'>Available</span>
                                <span className='orgTripDateSpan'>{slotDetails?.availableSlots ?? 0}</span>
                            </div>
                            {/* <div className='orgTripDateInfo'>
                                <span className='orgTripDateSpan'>Status</span>
                                <span className='orgTripDateSpan'>{actStatus}</span>
                            </div> */}
                        </div>
                    </div>
                </div>
            ) : (
                <EmptyPage />
            )}
            <button className='floatingPrintButton hideOnPrint' onClick={() => window.print()}>
                <Download /> Download
            </button>
            {actDateDetails && actDateDetails.length !== 0 ? (
                <CommonTable data={actDateDetails} columns={columns} />
            ) : (
                <EmptyPage />
            )}
            {modal && (
                <Dialog openModal={modal} heading={'Send Message'} loading={loading}>
                    <div className='dialogContent'>
                        <select
                            name='date'
                            id='date'
                            className='select w-full'
                            value={'whatsApp'}
                            onChange={(e) =>
                                setMessageData({
                                    ...messageData,
                                    msgType: e.target.value
                                })
                            }
                            disabled
                        >
                            <option value=''>Select Message Type</option>
                            {messageType.map((type) => (
                                <option value={type.value} key={type.value}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                        {messageData.msgType === 'whatsApp' && (
                            <input
                                placeholder='Whatsapp group link'
                                name='whatsapp'
                                onChange={(e) =>
                                    setMessageData({
                                        ...messageData,
                                        whatsApp: e.target.value
                                    })
                                }
                                value={messageData.whatsApp}
                                className='whatsAppLink'
                            />
                        )}
                        {/* {messageData.msgType !== 'rate' &&
                                            messageData.msgType !== 'whatsApp' && (
                                                <>
                                                    <textarea
                                                        className="messageArea"
                                                        value={messageData.message}
                                                        onChange={(e) =>
                                                            setMessageData({
                                                                ...messageData,
                                                                message: e.target.value
                                                            })
                                                        }
                                                    />
                                                    <CharCount
                                                        string={
                                                            messageData.message
                                                                ? messageData.message
                                                                : ''
                                                        }
                                                        min={10}
                                                        limit={50}
                                                    />
                                                </>
                                            )} */}
                        <p className='note'>
                            Note:{' '}
                            <span>The message will be sent to all the customers in this particular trip date</span>
                        </p>
                        <div className='alignCenter'>
                            <button className='dialogActBtn cancel' onClick={() => setModal(false)}>
                                Cancel
                            </button>
                            <button className='dialogActBtn submit' disabled={!messageData.msgType}>
                                Submit
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
            {showModal && (
                <ConfirmationModal
                    setShowModal={setShowModal}
                    handleConfirm={(e) => {
                        handleBookingCancel(e);
                    }}
                    message={'Do you want to cancel the booking?'}
                />
            )}
            {/* {cancelTripModal && (
                <ConfirmationModal
                    setShowModal={setCancelTripModal}
                    handleConfirm={(e) => handleTripCancel(e)}
                    message='Do you want to cancel the trip?'
                />
            )}{' '}
            {reviewModal && (
                <ConfirmationModal
                    setShowModal={setReviewModal}
                    handleConfirm={(e) => handleStopReview(e)}
                    message={'Do you want to stop the review?'}
                />
            )} */}
        </div>
    );
}
